import { observer } from 'mobx-react';
import { Component } from 'react';

import ActionButton from '../../app/shared/components/ActionButton';
import { Authorize } from '../authentication/Authorize';
import { AddedToCartModal } from '../configurator/AddedToCartModal/AddedToCartModal';
import { BuyerPolicy } from '../Policy';
import css from './ModularConfiguratorActions.css';
import { ModularConfiguratorActionsState } from './ModularConfiguratorActionsState';

interface ModularAddToShoppingCartActionProps {
  state: ModularConfiguratorActionsState;
}

@observer
export class ModularConfiguratorActions extends Component<ModularAddToShoppingCartActionProps, {}> {
  constructor(props: { state: ModularConfiguratorActionsState }) {
    super(props);
  }

  render() {
    const {
      state: { addToCartCommand, cartActionType, configurator, recentlyAddedItemModal, translation },
    } = this.props;

    return (
      <div className={css.container}>
        <Authorize policy={BuyerPolicy}>
          {configurator.canBePurchased && cartActionType === 'Add' && (
            <ActionButton
              className={css.buttonAddToCart}
              command={addToCartCommand}
              disabled={configurator.isLoadingConfigurationCode}
            >
              {translation.addToCartButton}
            </ActionButton>
          )}
          {/* {this.canBePurchased && cartActionType === 'Update' && (
            <ActionButton
              className={css.buttonAddToCart}
              command={updateCartItemCommand}
              disabled={configurationCodeLoading}
            >
              {translation.updateCartItemButton}
            </ActionButton>
          )} */}
        </Authorize>

        <AddedToCartModal state={recentlyAddedItemModal} actionType={cartActionType} />
      </div>
    );
  }
}
